export class DiaryDetailTypes {
  public static Other: string = "Other";
  public static Expiry: string = "Expiry";
  public static Option: string = "Option";
  public static Review: string = "Review";
}

export enum EventStatus {
  Completed = 'Completed',
  EventDatePassed = 'Event date passed',
  NoticeDatePassed = 'Notice date passed',
  NotStarted = 'Not started',
  Current = 'Current',
  Ended = 'Ended',
  NoticeServed = 'Notice Served',
  None = ''
}
